import React from 'react';

interface FeatureArticleHeroProps {
  children?: React.ReactNode;
}

export function FeatureArticleHero({ children }: FeatureArticleHeroProps) {
  return (
    <div className="overflow-hidden rounded-card bg-surface-panel">
      <div className="feature-hero-slot relative h-[680px] w-full overflow-hidden bg-surface-frost-05">
        {children ?? <div className="h-full w-full bg-surface-frost-10" />}
      </div>
    </div>
  );
}
